// RenderFields.jsx

import React from 'react';

const RenderFields = ({
  fields,
  formData,
  handleChange,
  readOnly = false,
  validationErrors = {},
}) => {
  return (
    <>
      {fields.map((field) => {
        const isFieldReadOnly = readOnly || field.readOnly;
        const isDisplayOnly = field.displayOnly;
        const fieldValue = formData[field.key] || '';

        return (
          <div key={field.key} className="flex items-center w-full mb-4">
            {/* Label */}
            <div style={{ width: '200px' }}>
              <label className="font-semibold">{field.label}</label>
            </div>

            {/* Dotted Line */}
            <div style={{ width: '100px', margin: '0 10px' }}>
              <span className="block border-dotted border-b-4 border-gray-200 w-full"></span>
            </div>

            {/* Input or Display Value */}
            <div style={{ flexGrow: 1 }}>
              {isDisplayOnly ? (
                <div
                  className={`p-2 border border-gray-300 rounded-md bg-gray-100 w-full ${
                    validationErrors[field.key] ? 'border-red-500' : ''
                  }`}
                >
                  {fieldValue || 'N/A'}
                </div>
              ) : (
                <input
                  type="text"
                  name={field.key}
                  className={`border ${
                    validationErrors[field.key]
                      ? 'border-red-500'
                      : 'border-gray-300'
                  } p-2 rounded-md w-full`}
                  value={fieldValue}
                  onChange={handleChange}
                  readOnly={isFieldReadOnly}
                  style={{
                    backgroundColor: isFieldReadOnly ? '#f3f4f6' : 'white',
                  }}
                />
              )}
            </div>
          </div>
        );
      })}
    </>
  );
};

export default RenderFields;
